module.exports = __webpack_public_path__ + "img/5.full.f83166ad.webp";